<template lang="html">
  <v-overlay
    :value="exibir || false"
    color="#FFF"
    opacity="1"
  >
    <v-container>
      <img
        src="../assets/logo-empresta.svg"
        alt="Carregando - Empresta Bem Melhor"
        title="Carregando - Empresta Bem Melhor"
        class="logo-empresta"
      >
      <v-progress-linear
        class="load-linear"
        :indeterminate="true"
      ></v-progress-linear>
    </v-container>
  </v-overlay>
</template>

<script lang="js">
export default  {
  name: 'loading',
  props: ['exibir'],
  data: () => ({
    
  }),
}
</script>

<style scoped lang="scss">
.logo-empresta {
  height: 5vw;
  min-height: 65px;
  max-height: 120px;
  margin-bottom: 10px;
}
</style>